import * as React from 'react'

type InputProps = React.ComponentProps<'input'> & {
  errors?: string[]
}

import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, errors, ...props }, ref) => {
    return (
      <>
        <input
          type={type}
          className={cn(
            'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            className
          )}
          ref={ref}
          {...props}
        />
        {errors && errors.length > 0 && (
          <p className={cn('text-base text-red-900')}>{errors.join(', ')}</p>
        )}
      </>
    )
  }
)
Input.displayName = 'Input'

export { Input }
